import { render } from "./ItemDimensionsControl.vue?vue&type=template&id=d675040c"
import script from "./ItemDimensionsControl.vue?vue&type=script&lang=js"
export * from "./ItemDimensionsControl.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__